import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';

import { connect } from 'react-redux';
import {
  authLogin as actionAuthLogin,
  authSignUp as actionAuthSignUp,
} from '../../../redux/auth/actions';
import {
  selectSignUpType,
  selectSignUpInvite,
} from '../../../redux/auth/selectors';

import { debounce } from 'lodash';

import API from '../../../services/API';
import { SIGNIN } from '../config';
import { validateEmail, validateNumber } from '../../../util/validation';
import { formatPhoneNumber, debounceWrapper } from '../../../util/util';

import qmStyles from '../../../theme/qmStyles';
import containerStyles from './InfoForm.scss';

import FormInput from '../../../components/FormInput';
import AddressAutocomplete from '../../../components/AddressAutocomplete/AddressAutocomplete';
import TermsAndPrivacy from '../components/TermsAndPrivacy';

class InfoFormBusiness extends Component {
  static propTypes = {
    navigateNext: PropTypes.func.isRequired,
    authSignUp: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    type: PropTypes.string.isRequired,
    inviteData: PropTypes.object,
    isBusiness: PropTypes.bool,
  };

  static defaultProps = {
    inviteData: null,
    isBusiness: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      address: '',
      name: '',
      phone: '',
      area: '',

      error: {},

      addressData: {},
      formSubmitSuccess: false,
      formSubmitFail: false,
    };

    this.postData = debounce(this.postData, 1337, {
      leading: true,
      trailing: false,
    });

    this.addressAutocomplete = React.createRef();
  }

  /**
   * @param type - state being modified
   * @param value - value to be used
   * @returns string value
   */
  formatInput = (type, value) => {
    if (type === 'zipCode') {
      if (value.length > 3) {
        const strippedString = value.replace(/ /g, '').slice(0, 6);
        return `${strippedString.slice(0, 3)} ${strippedString.slice(3, 6)}`;
      }
      return value;
    }
    if (type === 'phone') {
      return formatPhoneNumber(value);
    }
    return value;
  };

  /**
   * @param type - state being modified
   * @param value - value to be used
   * @returns string value
   */
  setFactory = field => event => {
    const formattedValue = this.formatInput(field, event.target.value);
    this.setState({
      [field]: formattedValue,
    });
  };

  validateData = () => {
    const { isBusiness } = this.props;
    const { email, phone, name, address, area, addressData } = this.state;

    const validateSelectedAddress = () => {
      if (this.addressAutocomplete && this.addressAutocomplete.current) {
        if (address && !addressData.street) {
          return false;
        }
        if (address && !addressData.street_number) {
          return false;
        }
      }
      return true;
    };

    if (!isBusiness) {
      if (!validateEmail(email)) return false;

      if (!name) return false;

      if (!address) return false;

      return validateSelectedAddress();
    }
    if (!validateEmail(email) && validateNumber(phone)) return false;

    if (!name) return false;

    if (!address) return false;

    if (!area) return false;

    return validateSelectedAddress();
  };

  postData = e => {
    e.preventDefault();
    if (!this.validateData()) {
      return;
    }
    const { isBusiness } = this.props;
    const { name, area, email, phone, addressData } = this.state;

    let payload = {
      meta: {
        email,
        phone,
        name,
        area,
        address: addressData,
      },
      action: 'KNOCK KNOCK Business',
    };

    if (!isBusiness) {
      payload = {
        meta: {
          email,
          name,
          address: addressData,
        },
        action: 'KNOCK KNOCK Homeowner',
      };
    }

    API.api
      .post('/requests/generic', payload)
      .then(({ data }) => {
        if (data.status < 300) {
          this.onSuccess();
        } else {
          throw data;
        }
      })
      .catch(error => {
        console.error(error);
        this.setState({
          error,
        });
      });
  };

  onSuccess = () => {
    const { navigateNext } = this.props;
    this.setState({
      formSubmitSuccess: true,
      error: false,
      formSubmitFail: false,
    });
    // navigateNext({ success: true });
  };

  onError = () => {
    const { navigateNext } = this.props;
    this.setState({
      formSubmitSuccess: false,
      error: true,
    });
    // navigateNext({ error: true });
  };

  render() {
    const { type, isBusiness } = this.props;
    const {
      email,
      address,
      name,
      phone,
      area,
      formSubmitSuccess,
      formSubmitFail,
    } = this.state;
    if (formSubmitSuccess) {
      return (
        <div
          style={{ padding: qmStyles.doubleGutter }}
          className={`${containerStyles.container} ${containerStyles.mainForm}`}
        >
          <h4 style={{ fontWeight: 'bold', marginBottom: qmStyles.gutter }}>
            Thank you for your interest!
          </h4>
          <p>We will be in touch with you as soon as possible.</p>
        </div>
      );
    }
    if (formSubmitFail) {
      return (
        <div
          style={{ padding: qmStyles.doubleGutter }}
          className={`${containerStyles.container} ${containerStyles.mainForm}`}
        >
          <h4 style={{ fontWeight: 'bold', marginBottom: qmStyles.gutter }}>
            Something went wrong!
          </h4>
          <p>Please go back and try again.</p>
        </div>
      );
    }
    return (
      <form
        className={containerStyles.container}
        onSubmit={debounceWrapper(this.postData)}
      >
        <div className={containerStyles.mainForm}>
          <p className={containerStyles.signUptitle}>
            Create your Account on Quartermaster
          </p>
          <FormInput
            value={name}
            label="Name"
            onChange={this.setFactory('name')}
            required
            style={{ marginBottom: qmStyles.halfGutter }}
          />
          <FormInput
            type="email"
            value={email}
            label="Email"
            onChange={this.setFactory('email')}
            style={{ marginBottom: qmStyles.halfGutter }}
            required
          />
          {isBusiness && (
            <FormInput
              type="tel"
              value={phone}
              label="Phone"
              onChange={this.setFactory('phone')}
              style={{ marginBottom: qmStyles.halfGutter }}
            />
          )}
          <AddressAutocomplete
            onAddressChange={addressObj => {
              this.setState({ address: addressObj.full_address });
            }}
            address={address}
            onAddressFinalized={addressParts => {
              this.setState({ addressData: addressParts });
            }}
            inputStyle={{ marginBottom: qmStyles.gutter, paddingRight: 30 }}
            ref={this.addressAutocomplete}
            required
          />
          {isBusiness && (
            <FormInput
              value={area}
              label="Service Area"
              onChange={this.setFactory('area')}
              required
              style={{ marginBottom: qmStyles.gutter }}
            />
          )}
          <FormInput
            type="submit"
            value="Send Request"
            style={{
              backgroundColor: qmStyles.qmBlue,
              width: '100%',
              color: 'white',
              lineHeight: 0,
              fontWeight: 'normal',
            }}
          />
          <TermsAndPrivacy />
          <div className={containerStyles.signInContainer}>
            <p className={containerStyles.signInTitle}>
              Already on Quartermaster?
              <Link className={containerStyles.signInLink} to={SIGNIN}>
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  type: selectSignUpType(state),
  inviteData: selectSignUpInvite(state),
});

const bindAction = {
  authLogin: actionAuthLogin,
  authSignUp: actionAuthSignUp,
};

export default withRouter(
  connect(
    mapStateToProps,
    bindAction,
  )(InfoFormBusiness),
);
